import { IEvent, HeartbeatEvents } from '@4tn/core-audio-player-shared';
import { trackLink } from '../trackLink';

import { startCounter, stopCounter, resetCounter, updateCurrentTime } from '../../heartbeat/Heartbeat';

export const streamHeartBeatTealiumEventHandler = (event: IEvent) => {
  const { name, media, time } = event;

  switch (name) {
    case HeartbeatEvents.START_HEARTBEAT:
      startCounter(media, trackLink, false);
      break;
    case HeartbeatEvents.STOP_HEARTBEAT:
      stopCounter();
      break;
    case HeartbeatEvents.RESET_HEARTBEAT:
      resetCounter();
      break;
    case HeartbeatEvents.UPDATE_TIME:
      updateCurrentTime(time);
      break;
    default:
      break;
  }
};
